module.exports = __webpack_public_path__ + "static/media/gc-beach-bad.7bd11614.png";